module.exports = __webpack_public_path__ + "img/ico_tab5_24personalconsultant@3x.78974c43.png";